import { InputLabel } from "@pepperstone/pepper-ui-kit";
import { useTranslation } from "react-i18next";
import type { DeleteFormData } from "@/components/delete-saved-payment-dialog/types";
import { getAssetUrl } from "@/utils/helpers";

export type DeleteConfirmationProps = {
  formData: DeleteFormData;
};

export const DeleteConfirmation = ({ formData }: DeleteConfirmationProps) => {
  const { t } = useTranslation();
  return (
    <div className="ps-flex ps-gap-4 ps-flex-col ps-py-4">
      <p className="ps-text-body-md">
        {t("deposit.methods.saved_methods.review_and_confirm_removal")}
      </p>
      <div className="ps-flex ps-flex-col ps-gap-2">
        <InputLabel
          htmlFor=""
          value={t("deposit.methods.saved_methods.reason_label")}
        />
        <p data-testid="delete-confirmation-reason-value">
          {formData.reason?.value}
        </p>
      </div>
      <div className="ps-flex ps-flex-col ps-gap-2">
        <InputLabel
          htmlFor=""
          value={t("deposit.methods.saved_methods.upload_proof_optional")}
        />
        <div className="ps-flex ps-gap-2 ps-items-center">
          {formData.file && (
            <div
              className="ps-w-10 ps-h-10 ps-rounded-sm ps-bg-icon-disabled"
              style={{ placeContent: "center" }}
            >
              <img
                src={
                  formData.file.value
                    ? URL.createObjectURL(formData.file.value)
                    : undefined
                }
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = getAssetUrl("document.svg", "icons");
                }}
                alt="preview"
              />
            </div>
          )}
          <span
            className="ps-inline-block ps-w-full ps-whitespace-nowrap ps-overflow-hidden"
            data-testid="delete-confirmation-file-name"
          >
            {formData.file
              ? formData.file?.value.name
              : t("deposit.methods.saved_methods.no_file_selected")}
          </span>
        </div>
      </div>
    </div>
  );
};
